import React, { Component } from "react";
import { connect } from 'react-redux';

/* Helpers */
/* import { history } from '../../../helpers/history';
import 'moment/locale/tr';
import locale from 'antd/es/date-picker/locale/tr_TR'; */

/* Services */
import AuthService from "../../../../services/auth.service";

/* Ant Design */
import { Typography } from 'antd';
import { CloseSquareOutlined } from '@ant-design/icons';

class StoreGameDetail extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <div>
                <p>Ebeveyn: {AuthService.getCurrentParent()._id}</p>
                <Typography.Title level={3}>Mağaza: Oyun Detayı Yapılacaklar</Typography.Title>
                <Typography.Text><CloseSquareOutlined /> Bu sayfadaki oyun detayı gösterilirken, backend'de yine de bu oyun satın alınmamışsa diye kontrol etmem gerekiyor</Typography.Text>
                <br />
            </div>
        )
    }
}

const mapState = (state) => ({
    parent: state.parent,
    // game: state.game,
});

const mapDispatch = (dispatch) => ({
    parentDispatch: dispatch.parent,
    // gameDispatch: dispatch.game,
});

export default connect(mapState, mapDispatch)(StoreGameDetail);